import styled from '@emotion/styled'
import { radius, spacing } from '@mobi/component-library/Theme/Common'

export const HeaderWrapperStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx2,

  '> *': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '> div': {
    padding: 0,
    wordBreak: 'unset',
    wordWrap: 'unset',
    textTransform: 'uppercase',
  },

  '> span:last-of-type': {
    flexShrink: 0,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '2rem',
    marginLeft: 'auto',
    paddingLeft: spacing.smx1,
    paddingRight: spacing.smx1,
    lineHeight: 1,
    fontWeight: 'normal',
    borderRadius: radius.pill,
    background: 'rgba(0,0,0,0.15)',
  },
})

export const MarketPillStyled = styled.span({
  display: 'inline-flex',
  gap: spacing.smx2,
  alignItems: 'center',
  fontWeight: 'normal',
  marginLeft: '-0.7rem',
  maxWidth: 'fit-content',
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  marginTop: '0.1rem',
  backgroundColor: 'rgba(0,0,0,0.5)',
  lineHeight: 1,
  padding: '0.3rem 0.7rem',
  borderRadius: '10rem',

  flexShrink: 0,
  '*': { flexShrink: 0 },
})
